<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dV1XqJ/tc-custom/9781615950881.jpg?1731789779391" alt="This image is the cover for the book Mad Dog & Englishman, Mad Dog & Englishman Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mad Dog & Englishman, Mad Dog & Englishman Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A suspenseful tale, told from the title to the end with wit and warmth by a very talented writer." —Nancy Pickard, award-winning author</b></p><p>Summer in Benteen County, Kansas, is a season possessed of all the gentle subtlety of an act of war. Winter, of course, is no better, but remembrance of its frosts and blizzards and winds that begin to suck away your life before you walk a dozen steps has grown faint by the early hours of a Sunday morning in late June. While some try to sleep, and Sheriff English and his ex-wife try sex, the Reverend Peter Simms takes an early walk in the park and encounters someone counting coup. When the Sheriff's part-Cheyenne brother, Mad Dog, arrives to meditate, he finds the Reverend's mutilated corpse. Mad Dog is the obvious suspect and he begins to hang out in the town jail while Sheriff English widens his net. English picks up several suspicious characters, and an increasingly dark history for the Simms family. The case grows stormier, and so does the weather. As a tornado gathers to hurl its fury on the hapless town, the fury of the killer rises to meet it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. M. Hayes
      </h2>
      
      <p class="authorDescription body article"><P>J M "Mike" Hayes was born and raised on the flat earth of Central Kansas. He studied anthropology at Wichita State University and the University of Arizona and lives in Tucson with his wife and a small herd of German Shepherds.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?371b0546